import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  getAllCleanerShifts,
  getAllVehicleSlots,
  getuserinformation,
  updateItem,
} from "../../utils/firebasefunctions";
import moment from "moment";

import { RotatingLines } from "react-loader-spinner";
import { IoMdCheckmark } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { PiVanFill } from "react-icons/pi";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import carlogo from "../images/car.png";
import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firestored, storage } from "../../firebase.config";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getStorage,
  deleteObject,
} from "firebase/storage";
import { useStateValue } from "../context/StateProvider";
import {
  GoogleMap,
  LoadScript,
  Polyline,
  Marker,
  OverlayView,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
const coordinates = [
  { lat: 37.78825, lng: -122.4324 },
  { lat: 37.78845, lng: -122.4358 },
  { lat: 37.78925, lng: -122.4374 },
  // Add more as needed
];

const containerStyle = {
  width: "100%",
  minHeight: "100%",
};

const darkTheme = [
  { elementType: "geometry", stylers: [{ color: "#212121" }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#181818" }],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#2c2c2c" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212121" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#000000" }],
  },
];

const center = coordinates[0]; // Center map on first coordinate

const EmployeeSlotPopUp = (props) => {
  const [{ user }, dispatch] = useStateValue();
  const [employeedata, setemployeedata] = useState();
  const [directions, setDirections] = useState(null);
  const [loading, setloading] = useState(false);
  const [taskloader, settaskloader] = useState(false);
  const [newtask, setnewtask] = useState("");
  const [newtaskimage, setnewtaskimage] = useState("");
  const [routecoordinates, setroutecoordinates] = useState([]);
  const [averagespeed, setaveragespeed] = useState(0);
  const [newtaskimagedata, setnewtaskimagedata] = useState("");
  const [currentspeed, setcurrentspeed] = useState(0);
  const [currentdirection, setcurrentdirection] = useState(0);
  const [galleryviewmodel, setgalleryviewmodel] = useState(false);
  const [galleryviewdata, setgalleryviewdata] = useState([]);
  const [gallerycounter, setgallerycounter] = useState(0);
  const popupref = useRef(null);
  const fileInput = useRef();

  const apikey = "AIzaSyDHDrEb9r2EEgcMLoWKp6aGVA9WIq0kIho";
  // const apikey = "AIzaSyD-4Q_BPIHXnGv1dqlaLOBKMM3mZRrPy4E";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  useEffect(() => {
    if (props.visible) {
      getusersactivitylogs(props.data.recordid);
    }
    setnewtask("");
  }, [props.data, props.visible]);

  useEffect(() => {
    if (
      props.data?.schedulecreationdate != undefined &&
      props.data?.shifttype == "Driver"
    ) {
      const subscriber = onSnapshot(
        doc(
          firestored,
          "TripHistory",
          props.data?.schedulecreationdate?.toString(),
        ),
        async (doc) => {
          if (doc.data()?.routecordinates?.length > 0) {
            let allcoordinates = doc.data()?.routecordinates;

            const CHUNK_SIZE = 100;
            let snappedPoints = [];

            // for (let i = 0; i < allcoordinates.length; i += CHUNK_SIZE) {
            //   const chunk = allcoordinates.slice(i, i + CHUNK_SIZE);
            //   const path = chunk.map((c) => `${c.lat},${c.long}`).join("|");
            //   const url = `https://roads.googleapis.com/v1/snapToRoads?path=${path}&interpolate=true&key=${apikey}`;

            //   try {
            //     const response = await fetch(url);
            //     const data = await response.json();

            //     if (data.snappedPoints) {
            //       snappedPoints.push(
            //         ...data.snappedPoints.map((p) => ({
            //           latitude: p.location.latitude,
            //           longitude: p.location.longitude,
            //         }))
            //       );
            //     }
            //   } catch (error) {
            //     console.error(`Chunk ${i / CHUNK_SIZE + 1} failed:`, error);
            //   }
            // }

            console.log(
              "refinedcoordinates lats longs " + JSON.stringify(snappedPoints),
            );
            setroutecoordinates(allcoordinates);

            // const path = querySnapshot
            //   .data()
            //   .routecordinates?.map(c => `${c.lat},${c.long}`)
            //   .join('|');
            // const url = `https://roads.googleapis.com/v1/snapToRoads?path=${path}&interpolate=true&key=AIzaSyDHDrEb9r2EEgcMLoWKp6aGVA9WIq0kIho`;

            // const response = await fetch(url);
            // const data = await response.json();

            // const refinedcoordinates = data?.snappedPoints?.map(p => ({
            //   latitude: p.location.latitude,
            //   longitude: p.location.longitude,
            // }));
            // alert(refinedcoordinates.length);

            // setcoordinates(querySnapshot.data().routecordinates || []);

            //    setroutecoordinates(doc.data().routecordinates);
            const validSpeeds = doc
              .data()
              .routecordinates.filter((item) => item.speed > 0);
            const totalSpeed = validSpeeds.reduce(
              (sum, item) => sum + item.speed,
              0,
            );
            const averageSpeed =
              validSpeeds.length > 0 ? totalSpeed / validSpeeds.length : 0;
            setaveragespeed(averageSpeed);

            setcurrentspeed(allcoordinates[allcoordinates.length - 1].speed);
            if (allcoordinates[allcoordinates.length - 1]?.heading > 0) {
              let newheading = 0;
              let selectedindex = allcoordinates.length - 1;
              if (
                allcoordinates[selectedindex]?.heading > 0 &&
                allcoordinates[selectedindex]?.heading <= 45
              ) {
                newheading = 45;
              } else if (
                allcoordinates[selectedindex]?.heading > 45 &&
                allcoordinates[selectedindex]?.heading <= 90
              ) {
                newheading = 90;
              } else if (
                allcoordinates[selectedindex]?.heading > 90 &&
                allcoordinates[selectedindex]?.heading <= 135
              ) {
                newheading = 135;
              } else if (
                allcoordinates[selectedindex]?.heading > 135 &&
                allcoordinates[selectedindex]?.heading <= 180
              ) {
                newheading = 180;
              } else if (
                allcoordinates[selectedindex]?.heading > 180 &&
                allcoordinates[selectedindex]?.heading <= 225
              ) {
                newheading = 225;
              } else if (
                allcoordinates[selectedindex]?.heading > 225 &&
                allcoordinates[selectedindex]?.heading <= 270
              ) {
                newheading = 270;
              } else if (
                allcoordinates[selectedindex]?.heading > 270 &&
                allcoordinates[selectedindex]?.heading <= 315
              ) {
                newheading = 315;
              } else {
                newheading = 360;
              }
              setcurrentdirection(newheading);
            }
          } else {
            setroutecoordinates([]);
          }
        },
      );

      // Cleanup subscription on unmount
      return () => subscriber();
    }
  }, [props.data, props.visible]);

  async function updatemultiusers(cleaningshiftid, sheduleddate) {
    let data = {
      tasks: newtask,
      completed: false,
    };

    if (newtaskimagedata != "") {
      const imageFile = newtaskimagedata.target.files[0];
      const storageRef = ref(
        storage,
        `taskpicture/${Date.now()}-${imageFile.name}`,
      );
      const uploadTask = uploadBytesResumable(storageRef, imageFile);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          toast.error("upload error " + error.message);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref)
            .then(async (downloadURL) => {
              data["taskimage"] = downloadURL;

              let taskdata = {
                tasks: arrayUnion(data),
              };
              await getAllCleanerShifts("slots", cleaningshiftid, sheduleddate)
                .then(async (response) => {
                  for (const key in response) {
                    await updateItem(
                      "slots",
                      response[key]?.schedulecreationdate,
                      taskdata,
                    )
                      .then(async (response) => {
                        let newdata = { ...employeedata };
                        let oldtasks = employeedata?.tasks;
                        oldtasks.push(data);

                        setnewtaskimage("");
                        setnewtaskimagedata("");
                        setnewtask("");
                        settaskloader(false);
                      })
                      .catch((err) => {
                        alert(err);
                        settaskloader(false);
                      });
                  }
                })
                .catch((err) => {
                  alert(err);
                  settaskloader(false);
                });
            })
            .catch((error) => {
              toast.error(error.message);
            });
        },
      );
    } else {
      let taskdata = {
        tasks: arrayUnion(data),
      };
      await getAllCleanerShifts("slots", cleaningshiftid, sheduleddate)
        .then(async (response) => {
          for (const key in response) {
            await updateItem(
              "slots",
              response[key]?.schedulecreationdate,
              taskdata,
            )
              .then(async (response) => {
                let newdata = { ...employeedata };
                let oldtasks = employeedata?.tasks;
                oldtasks.push(data);

                setnewtaskimage("");
                setnewtaskimagedata("");
                setnewtask("");
                settaskloader(false);
              })
              .catch((err) => {
                alert(err);
                settaskloader(false);
              });
          }
        })
        .catch((err) => {
          alert(err);
          settaskloader(false);
        });
    }
  }

  async function getusersactivitylogs(recordid) {
    await getuserinformation("slots", recordid)
      .then(async (response) => {
        setemployeedata(response);
      })
      .catch((err) => {
        alert(err);
      });
  }

  const handleimageChange = (event) => {
    fileInput.current.click();
  };

  const handleimageselected = (e) => {
    setnewtaskimagedata(e);
    setnewtaskimage(URL.createObjectURL(e.target.files[0]));
  };
  const Logs = (time, log) => {
    return (
      <div className="w-full flex flex-row">
        <p className="PoppinsRegular  text-lightgrey text-[15px]">{time}</p>
        <p className="ml-[10px] PoppinsRegular  text-textcolor text-[15px]">
          {log}
        </p>
      </div>
    );
  };

  const Notes = (note, index) => {
    return (
      <div className="w-full flex flex-row">
        <p className="PoppinsRegular  text-lightgrey text-[15px]">
          {index + 1 + "."}
        </p>
        <p className="ml-[5px] PoppinsRegular  text-lightgrey text-[15px]">
          {note}
        </p>
      </div>
    );
  };

  const LabelStats = (heading, data) => {
    return (
      <div className="w-full flex flex-row justify-between">
        <p className="PoppinsRegular  text-textcolor text-[15px]">{heading}</p>
        <p className="PoppinsRegular  text-textcolor text-[15px]">{data}</p>
      </div>
    );
  };

  const renderexpresstasks = (item, index, inneritem, innerindex, state) =>
    employeedata?.status == "Accepted" &&
    employeedata?.checkindatetime != undefined ? (
      <div className="flex flex-col justify-center items-start     bg-themelightblack  drop-shadow-lg p-4 rounded-lg relative w-full mt-[10px]">
        <div className="w-full flex flex-row ">
          <div className="flex w-full flex-row items-center">
            <p className=" PoppinsRegular  text-textcolor text-[15px]">
              {inneritem.task}
            </p>
          </div>
          <div className="flex ">
            <p
              className={`PoppinsRegular  ${
                (state == "pickup" && inneritem?.pickupup) ||
                (state == "completed" && inneritem?.completed)
                  ? "text-themegreen"
                  : "text-orange-500"
              } text-[15px]`}
            >
              {state == "pickup" && inneritem?.pickupup
                ? "Picked"
                : state == "completed" && inneritem?.completed
                  ? "Completed"
                  : "Pending"}
            </p>
          </div>
        </div>
      </div>
    ) : (
      <div className="flex flex-col justify-center items-start     bg-themelightblack  drop-shadow-lg p-4 rounded-lg relative w-full mt-[10px]">
        <p className="PoppinsRegular text-white text-sm     text-start ">
          {inneritem.task}
        </p>
      </div>
    );

  const ShiftStatus = () => {
    return (
      <div className="w-full py-[20px] px-[15px]">
        <div className="w-full flex flex-row justify-between">
          <p className="PoppinsRegular  text-textcolor text-[15px]">Date:</p>
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            {props.data.selecteddate}
          </p>
        </div>
        <div className="w-full flex flex-row justify-between">
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            Shift Start Time:
          </p>
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            {props.data.starttime ? props.data.starttime : "Not Assigned"}
          </p>
        </div>
        <div className="w-full flex flex-row justify-between">
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            Shift End Time:
          </p>
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            {props.data.endtime ? props.data.endtime : "Not Assigned"}
          </p>
        </div>
        {props.data.shifttype == "Driver" && routecoordinates.length > 0 && (
          <div className="w-full flex flex-row justify-between">
            <p className="PoppinsRegular  text-textcolor text-[15px]">
              Average Speed:
            </p>
            <p className="PoppinsRegular  text-textcolor text-[15px]">
              {`${
                averagespeed > 0 ? parseFloat(averagespeed).toFixed(1) : 0
              } km/hr`}
            </p>
          </div>
        )}
        {employeedata?.checkoutdatetime != undefined && (
          <div className="w-full flex flex-row justify-between">
            <p className="PoppinsRegular  text-textcolor text-[15px] flex flex-row">
              Hours Worked
              <p
                className={`${
                  employeedata?.hoursapproved == true
                    ? "text-themegreen"
                    : employeedata?.hoursapproved == false
                      ? "text-red-500"
                      : "text-textcolor"
                }  ml-[5px] text-[14px]`}
              >{`${
                employeedata?.hoursapproved == true
                  ? " (Approved):"
                  : employeedata?.hoursapproved == false
                    ? " (Rejected):"
                    : ":"
              }`}</p>
            </p>
            <p
              className={`PoppinsRegular   text-[15px] ${
                employeedata?.hoursapproved == true
                  ? "text-themegreen"
                  : employeedata?.hoursapproved == false
                    ? "text-red-500"
                    : "text-textcolor"
              }`}
            >
              {employeedata?.minutes
                ? parseInt(employeedata?.minutes / 60) +
                  " hrs " +
                  parseInt(employeedata?.minutes % 60) +
                  " mins"
                : "NA"}
            </p>
          </div>
        )}

        {employeedata?.checkoutdatetime != undefined &&
          employeedata?.hoursapproved != "noaction" && (
            <div className="w-full flex flex-row justify-between">
              <p className="PoppinsRegular  text-textcolor text-[15px] flex flex-row">
                {employeedata?.hoursapproved == true
                  ? "Approved By:"
                  : "Rejected By:"}
              </p>
              <p
                className={`PoppinsRegular   text-[15px] ${
                  employeedata?.hoursapproved == true
                    ? "text-themegreen"
                    : "text-red-500"
                }`}
              >
                {employeedata?.approvalstatusupdatedby
                  ? employeedata?.approvalstatusupdatedby
                  : "NA"}
              </p>
            </div>
          )}

        {props.data?.item?.shifttype == "Driver" &&
          props.data.item.expressdelivery &&
          employeedata && (
            <>
              <p className="pt-[10px] PoppinsRegular  text-textcolor">
                Pick Up:
              </p>
              <p className="PoppinsRegular text-white/80 text-md  text-start  mt-[5px] uppercase">
                {employeedata?.pickupdestinations[0]?.pickupaddress.label}
              </p>
              <div className="flex flex-col justify-center items-start      bg-themeColor  drop-shadow-lg p-4 rounded-lg relative w-full mt-[10px]">
                {LabelStats(
                  "Pick Up Date",
                  employeedata.pickupdestinations[0]?.pickupdate,
                )}
                {LabelStats(
                  "Pick Up Time",
                  employeedata.pickupdestinations[0].pickuptime,
                )}
                {LabelStats(
                  "Contact person",
                  employeedata.pickupdestinations[0].contactperson,
                )}
                {LabelStats(
                  "Phone Number",
                  employeedata.pickupdestinations[0].phonenumber,
                )}
                <p className="pt-[5px] PoppinsRegular text-[15px] text-red-600">
                  {employeedata.pickupdestinations[0].notes}
                </p>

                {employeedata.pickupdestinations[0].tasks.map((item, index) =>
                  item.notetorider.map((inneritem, innerindex) =>
                    renderexpresstasks(
                      item,
                      index,
                      inneritem,
                      innerindex,
                      "pickup",
                    ),
                  ),
                )}
              </div>
              <p className="pt-[10px] PoppinsRegular  text-textcolor">
                Drop Off:
              </p>

              {employeedata.pickupdestinations[0].tasks.map(
                function (item, index) {
                  return (
                    <div className="flex flex-col justify-center items-start      bg-themeColor  drop-shadow-lg p-4 rounded-lg relative w-full mt-[10px]">
                      <p className="PoppinsRegular text-white/80 text-md  text-start  my-[5px] uppercase">
                        {item.dropoffdestination.destination}
                      </p>

                      {LabelStats(
                        "Drop Off Date",
                        item.dropoffdestination.deliverydate,
                      )}
                      {LabelStats(
                        "Drop Off Time",
                        item.dropoffdestination.deliverytime,
                      )}
                      {LabelStats(
                        "Contact person",
                        item.dropoffdestination.contactperson,
                      )}
                      {LabelStats(
                        "Phone Number",
                        item.dropoffdestination.phonenumber,
                      )}
                      <p className="pt-[5px] PoppinsRegular text-[15px] text-red-600">
                        {item.dropoffdestination.notes}
                      </p>
                      {item.notetorider.map((inneritem, innerindex) =>
                        renderexpresstasks(
                          item,
                          index,
                          inneritem,
                          innerindex,
                          "completed",
                        ),
                      )}
                    </div>
                  );
                },
              )}
            </>
          )}
        {employeedata?.tasks != undefined && employeedata?.tasks.length > 0 && (
          <>
            <p className="pt-[10px] PoppinsRegular  text-textcolor">Tasks:</p>
            {employeedata?.tasks.map((item, ind) => {
              return (
                <div className="w-full flex flex-col">
                  <div className="w-full flex flex-row ">
                    <div className="flex w-full flex-row items-center">
                      {!item.completed && !item.rejected && (
                        <FaCircleMinus
                          onClick={async () => {
                            let data = { ...employeedata };
                            data.tasks = data?.tasks.filter(
                              function (itemdata, innerkey) {
                                return innerkey != ind;
                              },
                            );
                            setemployeedata(data);
                            await updateItem("slots", props.data.recordid, data)
                              .then(async (response) => {
                                if (response == "success") {
                                  props.filtertasks(
                                    props.data.recordid,
                                    data.tasks,
                                  );
                                } else {
                                  toast.warn(
                                    "Something went wrong. Please try again later!",
                                  );
                                }
                              })
                              .catch((error) => {
                                toast.warn(
                                  "Something went wrong. Please try again later!",
                                );
                              });
                          }}
                          className=" text-red-500 w-[13px] h-[13px] hover:cursor-pointer mr-[10px]"
                        />
                      )}
                      <p className=" PoppinsRegular  text-textcolor text-[15px]">
                        {item.tasks}
                      </p>
                      <p className=" PoppinsRegular  text-red-500 text-[12px] ml-[5px]">
                        {item?.late && employeedata?.shifttype != "Cleaner"
                          ? " (Late)"
                          : null}
                      </p>
                      {/* <p className="PoppinsRegular  text-textcolor text-[15px]">{`deadline: ${moment(item.deadlinetimestamp).format('hh:mm')}`}</p> */}
                    </div>
                    <div className="flex ">
                      <p
                        className={`PoppinsRegular  ${
                          item.completed
                            ? "text-themegreen"
                            : item.rejected
                              ? "text-red-500"
                              : "text-orange-500"
                        } text-[15px]`}
                      >
                        {item.completed
                          ? "Completed"
                          : item.rejected
                            ? "Rejected"
                            : "Pending"}
                      </p>
                    </div>
                  </div>
                  {item?.rejectionimage != "" &&
                    item?.rejectionimage != undefined && (
                      <img
                        loading="lazy"
                        src={item?.rejectionimage}
                        className="w-[200px] h-[100px]  object-cover my-[5px]"
                      />
                    )}
                  {item?.rejectionreason && (
                    <p className=" PoppinsRegular  text-red-500 text-[15px]">
                      {item?.rejectionreason}
                    </p>
                  )}
                </div>
              );
            })}
          </>
        )}

        {props.data?.item?.shifttype == "Cleaner" &&
          employeedata?.checkoutdatetime == undefined && (
            <>
              {newtaskimage && (
                <div className="flex w-full justify-center mt-[15px]">
                  <div className="flex relative w-[110px] h-[110px]">
                    <div
                      onClick={() => {
                        setnewtaskimage("");
                        setnewtaskimagedata("");
                      }}
                      className="bg-themeblue h-[25px] w-[25px]  rounded-full flex  items-center justify-center position absolute right-[-5px] top-[-5px]"
                    >
                      <IoIosCloseCircle className=" text-white  w-[15px] h-[15px] hover:cursor-pointer" />
                    </div>

                    <img
                      loading="lazy"
                      src={newtaskimage}
                      className="w-[100%] h-[100%] object-cover rounded-md "
                    />
                  </div>
                </div>
              )}
              <input
                type="file"
                style={{ display: "none" }}
                ref={fileInput}
                onChange={handleimageselected}
              />
              <textarea
                type="text"
                placeholder="Enter task..."
                rows={1}
                value={newtask}
                onChange={(event) => {
                  setnewtask(event.target.value);
                }}
                className={`input  px-4 ${
                  newtask == "" ? " text-lighttextGray " : "text-black"
                } text-sm  PoppinsRegular mt-[10px]  w-full h-[65px] rounded-xl border border-bordercolor items-center flex `}
              />
              <div className="w-full flex justify-end  mt-[10px]">
                {taskloader ? (
                  <div className="">
                    <RotatingLines
                      visible={true}
                      height="25"
                      width="25"
                      strokeColor="#00C763"
                      color="grey"
                      strokeWidth="5"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                ) : (
                  <div className="flex flex-row ">
                    <div
                      onClick={handleimageChange}
                      className={`rounded-md w-[90px] h-[30px] bg-themeblue flex items-center justify-center hover:cursor-pointer`}
                    >
                      <p className=" PoppinsRegular  text-white text-[12px] ">
                        Add Image
                      </p>
                    </div>
                    <div
                      onClick={() => {
                        if (newtask != "") {
                          settaskloader(true);

                          updatemultiusers(
                            props.data?.item?.cleaningshiftid,
                            props.data?.item?.sheduleddate,
                          );
                        }
                      }}
                      className={`ml-[5px] rounded-md w-[70px] h-[30px] ${
                        newtask != "" ? "bg-themeblue" : "bg-lighttextGray"
                      } flex items-center justify-center hover:cursor-pointer`}
                    >
                      <p className=" PoppinsRegular  text-white text-[12px] ">
                        Add Task
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

        {props.data?.item?.shifttype == "Driver" && (
          <div className="">
            {Heading("Vehicle Details:")}
            {Stats("Vehicle Number:", `${employeedata?.vehiclenumber}`)}

            {user.clientrole != true &&
              Stats(
                "Vehicle Trip start:",
                `${employeedata?.vehiclecheckinkms || "N/A"} km`,
                [
                  ...(employeedata?.mileagevehicleimages?.[0]
                    ? [employeedata.mileagevehicleimages[0]]
                    : []),
                  ...(employeedata?.vehiclecheckinimages ?? []),
                ],
              )}
            {user.clientrole != true &&
              Stats(
                "Vehicle Trip end:",
                `${employeedata?.vehiclecheckoutkms || "N/A"} km`,
                [
                  ...(employeedata?.mileagevehicleimages?.[1]
                    ? [employeedata.mileagevehicleimages[1]]
                    : []),
                  ...(employeedata?.vehiclecheckoutimages ?? []),
                ],
              )}

            {user.clientrole != true &&
              employeedata?.vehiclereportimages &&
              Stats("Vehicle Report", "", employeedata?.vehiclereportimages)}
          </div>
        )}

        {user.clientrole != true && (
          <>
            {Heading("Today's Shift Logs:")}

            {employeedata == undefined && (
              <p className="PoppinsRegular  text-textcolor text-[15px]">
                Not Available
              </p>
            )}

            {employeedata?.onthewaytime != undefined &&
              Logs(
                moment(employeedata?.onthewaytime).format("H:mm"),
                "Marked on the way",
              )}
            {employeedata?.checkindatetime != undefined &&
              Logs(
                moment(employeedata?.checkindatetime).format("H:mm"),
                "Checked In",
              )}
            {employeedata?.lunchindatetime != undefined &&
              Logs(
                moment(employeedata?.lunchindatetime).format("H:mm"),
                "Lunch In",
              )}
            {employeedata?.lunchoutdatetime != undefined &&
              Logs(
                moment(employeedata?.lunchoutdatetime).format("H:mm"),
                "Lunch Out",
              )}
            {employeedata?.checkoutdatetime != undefined &&
              Logs(
                moment(employeedata?.checkoutdatetime).format("H:mm"),
                "Checked Out",
              )}

            {employeedata?.additionalnotes != undefined && (
              <>
                <p className="pt-[10px] PoppinsRegular  text-textcolor">
                  Additional Notes:
                </p>

                {employeedata.additionalnotes.map(function (item, index) {
                  return Notes(item, index);
                })}
              </>
            )}
          </>
        )}
      </div>
    );
  };

  const Heading = (title) => {
    return <p className="pt-[10px] PoppinsRegular  text-textcolor ">{title}</p>;
  };
  const Stats = (title, description, data) => {
    return (
      <div className="flex w-full flex-col">
        <div className="w-full flex flex-row justify-between ">
          <p className="PoppinsRegular  text-textcolor text-[15px]">{title}</p>
          <p className="PoppinsRegular  text-textcolor text-[15px]">
            {description}
          </p>
        </div>
        {data?.length > 0 && Vehicleimages(data, title)}
      </div>
    );
  };

  const Vehicleimages = (data, title) => {
    return (
      <div
        className={`w-full flex flex-row ${
          title == "Vehicle Report" ? "flex-start" : "justify-between"
        } items-center mt-[5px] mb-[10px]`}
      >
        {data?.map(function (item, index) {
          return (
            <img
              loading="lazy"
              onClick={() => {
                setgalleryviewdata(data);
                setgallerycounter(0);
                setgalleryviewmodel(true);
              }}
              src={item}
              className={`w-[19%] h-[200px]  object-cover rounded-md ${
                title == "Vehicle Report" ? "mr-[8px]" : null
              }`}
            />
          );
        })}
      </div>
    );
  };

  const Livelocation = () => {
    // const origin = {
    //   lat: routecoordinates[0]?.lat,
    //   lng: routecoordinates[0]?.long,
    // };
    // const destination = {
    //   lat: routecoordinates[routecoordinates.length - 1]?.lat,
    //   lng: routecoordinates[routecoordinates.length - 1]?.long,
    // };
    // const waypoints = routecoordinates.slice(1, -1).map((point) => ({
    //   location: { lat: point.lat, lng: point.long },
    //   stopover: false,
    // }));
    return (
      <LoadScript googleMapsApiKey={apikey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{
            lat: routecoordinates[routecoordinates.length - 1]?.lat,
            lng: routecoordinates[routecoordinates.length - 1]?.long,
          }}
          options={{
            styles: darkTheme, // apply dark theme
            disableDefaultUI: false, // hide default controls if you want
          }}
          // center={destination}
          zoom={16}
        >
          <Polyline
            // path={routecoordinates}
            path={routecoordinates.map((coord) => ({
              lat: coord.lat,
              lng: coord.long,
            }))}
            options={{
              strokeColor: "#007aff",
              strokeOpacity: 0.8,
              strokeWeight: 4,
            }}
          />

          <Marker
            position={{
              lat: routecoordinates[0]?.lat,
              lng: routecoordinates[0]?.long,
            }}
            label="Start"
          />

          <OverlayView
            position={{
              lat: routecoordinates[routecoordinates.length - 1]?.lat,
              lng: routecoordinates[routecoordinates.length - 1]?.long,
            }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div style={{ transform: "translate(-50%, -60%)" }}>
              {/* <PiVanFill
                style={{
                  transform: [
                    {
                      rotate: `${currentdirection}deg`,
                    },
                    {
                      scaleY:
                        currentdirection > 0 && currentdirection < 180 ? -1 : 1,
                    },
                  ],
                }}
                className=" text-themeColor w-[20px] h-[20px] "
              /> */}
              <img
                loading="lazy"
                src={carlogo}
                style={{
                  transform: `rotate(${currentdirection}deg)`,
                }}
                className="w-[35px] h-[35px] object-contain rounded-full"
              />
              {/* <p>{currentdirection}</p> */}
            </div>
          </OverlayView>

          {/* <DirectionsService
            options={{
              origin,
              destination,
              waypoints,
              travelMode: "DRIVING",
            }}
            callback={(result, status) => {
              alert(status);
              if (status === "OK") {
                setDirections(result);
              } else {
                console.error("Directions request failed", result);
              }
            }}
          />


          {directions && (
            <DirectionsRenderer
              options={{
                directions,
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: "#007aff",
                  strokeWeight: 4,
                },
              }}
            />
          )}


          <Marker position={origin} label="Start" />


          <OverlayView
            position={destination}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div style={{ transform: "translate(-50%, -100%)" }}>
              <PiVanFill className="text-themeColor w-[20px] h-[20px]" />
            </div>
          </OverlayView> */}
        </GoogleMap>
      </LoadScript>
    );
  };

  const Approvalbutton = (type) => {
    return (
      <div
        onClick={async () => {
          setloading(true);
          if (employeedata.shifttype == "Driver") {
            await getAllVehicleSlots(
              "slots",
              "assignedvehicle",
              "==",
              employeedata.assignedvehicle,
            )
              .then(async (response) => {
                console.log(
                  " this is vehichle response " + JSON.stringify(response),
                );
                const findindex = response.findIndex(
                  (item) =>
                    item.schedulecreationdate ===
                    employeedata.schedulecreationdate,
                );
                if (response[findindex]?.hoursapproved) {
                  let imagedata = [
                    ...response[findindex]?.vehiclecheckinimages,
                    ...response[findindex]?.vehiclecheckoutimages,
                  ];
                  imagedata.push(response[findindex]?.vehiclereportimage);

                  for (const key in imagedata) {
                    try {
                      const storage = getStorage();
                      const fileRef = ref(storage, imagedata[key]);
                      await deleteObject(fileRef);
                      toast.success("Image deleted successfully");
                      console.log("File deleted successfully");
                    } catch (error) {
                      console.error("Error deleting file:", error);
                      toast.warn(
                        "Image file has already been deleted. Removing from slot...",
                      );
                    }
                  }
                  let dataimagedataset = {
                    vehiclecheckinimages: [],
                    vehiclecheckoutimages: [],
                    vehiclereportimage: null,
                  };

                  await updateItem(
                    "slots",
                    response[findindex]?.schedulecreationdate,
                    dataimagedataset,
                  )
                    .then(async (response) => {})
                    .catch((error) => {
                      toast.warn(
                        "Something went wrong while deleting images. Please try again later!",
                      );
                    });
                }
              })
              .catch((err) => {
                console.log(err);
                alert(err);
              });
          }

          let data = {
            hoursapproved: type == "cross" ? false : true,
            approvalstatusupdatedby: user.firstname + " " + user.lastname,
            approvalstatusupdatedbyid: user.id,
          };
          await updateItem("slots", props.data.recordid, data)
            .then(async (response) => {
              if (response == "success") {
                let dataset = { ...employeedata };
                dataset["hoursapproved"] = data.hoursapproved;
                dataset["approvalstatusupdatedby"] =
                  data.approvalstatusupdatedby;
                dataset["approvalstatusupdatedbyid"] =
                  data.approvalstatusupdatedbyid;
                setemployeedata(dataset);

                if (props.data.item.manualhours) {
                  props.onmanualhourapprovedsuccess(
                    props.data.id,
                    props.data.recordid,
                    `Your manual hour shift request for ${props.data.starttime + " - " + props.data.endtime} has been ${type == "cross" ? "declined" : "approved"}`,
                    type == "cross" ? false : true,
                  );
                }

                props.onapprovalsuccess(
                  props.data.recordid,
                  data.hoursapproved,
                );

                setloading(false);
              } else {
                setloading(false);
                toast.warn("Something went wrong. Please try again later!");
              }
            })
            .catch((error) => {
              setloading(false);

              toast.warn("Something went wrong. Please try again later!");
            });
        }}
        className="h-[40px] w-[40px] flex items-center justify-center  hover:cursor-pointer"
      >
        {type == "check" ? (
          <IoMdCheckmark className="text-themegreen text-[40px]" />
        ) : (
          <RxCross2 className="text-red-500 text-[40px]" />
        )}
      </div>
    );
  };

  // Supervisors can only approve/reject if they have approval permission for this slot's project
  const hasapprovalpermission =
    user?.projectassigned?.find(
      (data) => data.project == props.data?.item?.projectid,
    )?.approvalpermission == true;

  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.4)] flex items-center justify-center ">
        <div
          ref={popupref}
          className="w-[600px]   bg-themelightblack border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col overflow-hidden max-h-[90%]  "
        >
          <div className="flex w-full h-[200px] relative">
            <img
              loading="lazy"
              src={props.data.picture}
              className="w-full h-[200px]  object-cover  "
            />

            {props.data.status == "Accepted" &&
              props.data.shifttype == "Driver" &&
              props.visible && (
                <div className="flex absolute z-10 top-0 w-full h-full ">
                  {Livelocation()}
                  <p className="absolute PoppinsRegular  text-textcolor text-[15px] top-[60px] left-[12px]">
                    {`${
                      currentspeed > 0 ? parseFloat(currentspeed).toFixed(1) : 0
                    } km/hr`}
                  </p>
                </div>
              )}
          </div>
          {props.data.item.expressdelivery && (
            <div className="w-full bg-red-700 flex justify-center items-center py-1">
              <p className="PoppinsRegular  text-textcolor">
                {"Express Delivery"}
              </p>
            </div>
          )}
          {props.data.item.manualhours &&
            props.data.item?.manualhoursaddedby == "employee" && (
              <div className="w-full  bg-themeblue flex justify-center items-center py-1">
                <p className="PoppinsRegular  text-textcolor">
                  {"Manual Hours added by Employee"}
                </p>
              </div>
            )}
          <div className=" flex w-full items-center justify-start flex-col overflow-hidden max-h-[80%] overflow-y-scroll">
            <div className="w-full flex flex-row justify-between items-start pt-[15px]  px-[15px]">
              <div className="flex flex-col ">
                <p className="PoppinsRegular  text-textcolor">
                  {props.data.name}
                </p>
                <p className="PoppinsRegular  text-lightgrey text-[14px]">
                  {props.data.designation}
                </p>
              </div>
              <p
                className={`PoppinsRegular  text-textcolor ${
                  employeedata?.checkoutdatetime
                    ? "text-red-500"
                    : employeedata?.checkindatetime
                      ? "text-themeblue"
                      : "text-orange-500"
                }`}
              >
                {employeedata?.checkoutdatetime
                  ? "Checked Out"
                  : employeedata?.checkindatetime
                    ? "Checked In"
                    : employeedata?.onthewaytime
                      ? "On The Way"
                      : "Pending"}
              </p>
            </div>

            {ShiftStatus()}

            {employeedata?.hoursapproved != true &&
              employeedata?.checkindatetime != undefined &&
              employeedata?.checkoutdatetime != undefined &&
              user.clientrole != true &&
              hasapprovalpermission && (
                <>
                  {loading ? (
                    <div className="py-[20px]">
                      <RotatingLines
                        visible={true}
                        height="25"
                        width="25"
                        strokeColor="#00C763"
                        color="grey"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  ) : (
                    <div className="flex flex-row w-full justify-evenly px-[30%] pb-[20px]">
                      {employeedata?.hoursapproved != false && (
                        <>{Approvalbutton("cross")}</>
                      )}
                      {Approvalbutton("check")}
                    </div>
                  )}
                </>
              )}
            {/* <p className="text-center">{props.text}</p>

<div className="flex w-full justify-between items-center flex-row mt-[10px]">
<button
                    onClick={() => {
props.accept()
                    }}
                    type='submit' className='text-center py-2 rounded-md  bg-themeColor hover:bg-themeColor/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase'>
                    Yes
                </button>
                <button
                    onClick={() => {
                        props.cancel()
                    }}
                    type='submit' className='text-center py-2 rounded-md  bg-lighttextGray hover:bg-lighttextGray/80 w-[45%]  mx-auto text-white text-sm  PoppinsRegular uppercase'>
                  No
                </button>
</div> */}
          </div>
          {galleryviewmodel && (
            <div className=" fixed z-10  top-[0] left-[0] w-full h-screen border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col overflow-hidden  ">
              <div className=" w-full h-full bg-black flex items-center justify-center p-[50px] ">
                <div className="w-full h-full flex items-center justify-center relative">
                  <div
                    onClick={() => {
                      if (gallerycounter == 0) {
                        setgallerycounter(galleryviewdata.length - 1);
                      } else {
                        let newcount = gallerycounter - 1;
                        setgallerycounter(newcount);
                      }
                    }}
                    className=" hover:cursor-pointer position absolute left-0"
                  >
                    <IoIosArrowBack className="   w-[50px] h-[50px]  text-white" />
                  </div>
                  <div
                    onClick={() => {
                      if (gallerycounter < galleryviewdata.length - 1) {
                        let newcount = gallerycounter + 1;
                        setgallerycounter(newcount);
                      } else {
                        setgallerycounter(0);
                      }
                    }}
                    className="hover:cursor-pointer position absolute right-0"
                  >
                    <IoIosArrowForward className="   w-[50px] h-[50px] position absolute right-0 text-white" />
                  </div>

                  <div
                    onClick={() => {
                      setgalleryviewdata([]);
                      setgallerycounter(0);
                      setgalleryviewmodel(false);
                    }}
                    className=" h-[50px] w-[50px]  rounded-full flex  items-center justify-center position absolute right-[-5px] top-[-5px]"
                  >
                    <IoIosCloseCircle className=" text-white  w-[30px] h-[30px] hover:cursor-pointer" />
                  </div>
                  <img
                    loading="lazy"
                    src={galleryviewdata[gallerycounter]}
                    className="w-full h-full object-contain rounded-md "
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default EmployeeSlotPopUp;
